import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TokenService} from '../services/token.service';

/**
 * Redirect layout used for refreshing token and/or redirecting to specific components
 */

@Component({
  selector: 'app-redirect',
  template: ''
})
export class RedirectComponent {

  constructor(private tokenService: TokenService, private route: ActivatedRoute, private router: Router) {
    const refreshToken = route.snapshot.queryParams.refreshToken;
    const redirectUrl = route.snapshot.queryParams.redirectTo;
    if (refreshToken) {
      this.refreshToken(refreshToken, redirectUrl);
    } else {
      if (redirectUrl) {
        router.navigateByUrl(redirectUrl);
      } else {
        router.navigate(['']);
      }
    }
  }

  refreshToken(refreshToken, redirectUrl) {
    this.tokenService.refreshToken().subscribe(
      result => {
        if (result.success) {
          this.onSuccessfulTokenRefresh(result);
          this.router.navigateByUrl(redirectUrl);
        } else {
          this.navigateToLogout(redirectUrl);
        }
      },
      () => {
        this.navigateToLogout(redirectUrl);
      }
    );
  }

  navigateToLogout(redirectUrl: string) {
    this.router.navigate(['/logout'], {queryParams: {redirectUrl}});
  }

  private onSuccessfulTokenRefresh(result) {
    const response = result.data;
    const token = response.token;
    const refreshToken = response.refreshToken;
    this.tokenService.saveToken(token);
    this.tokenService.saveRefreshToken(refreshToken);
  }
}
